<template>
  <label
    class="checkbox"
    :class="{
      'checkbox--active': (value === null && checkbox_value) || (value !== null && checkbox_value.includes(value)),
      'checkbox--disabled': disabled,
    }"
  >
    <input
      v-if="value === null"
      v-model="checkbox_value"
      class="checkbox-item"
      type="checkbox"
      :disabled="disabled"
    >

    <input
      v-else
      v-model="checkbox_value"
      class="checkbox-item"
      type="checkbox"
      :value="value"
      :disabled="disabled"
    >

    <div
      class="checkbox-container"
      :class="{
        'checkbox-container--big': big,
        'checkbox-container--small': small,
      }"
    >
      <template v-if="value === null">
        <svg-element
          v-if="checkbox_value && !indeterminate"
          icon="valid"
          :size="svg_size"
        />

        <svg-element
          v-if="checkbox_value && indeterminate"
          icon="less"
          :size="svg_size"
        />
      </template>

      <template v-else>
        <svg-element
          v-if="checkbox_value.includes(value) && !indeterminate"
          icon="valid"
          :size="svg_size"
        />

        <svg-element
          v-if="checkbox_value.includes(value) && indeterminate"
          icon="less"
          :size="svg_size"
        />
      </template>
    </div>

    <div class="text nds-text-p">
      {{ label }}
    </div>
  </label>
</template>

<script>
import SvgElement from '@/components/elements/SvgElement.vue';

export default {
  name: 'CheckboxElement',
  components: {
    SvgElement,
  },
  props: {
    big: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    label: String,
    // eslint-disable-next-line vue/prop-name-casing
    modelValue: {
      type: [Array, Boolean],
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Boolean, Number, String],
      default: null,
    },
  },
  emits: [
    'change',
    'update:modelValue',
  ],
  computed: {
    svg_size() {
      if (this.big) {
        return 14;
      }

      if (this.small) {
        return 6;
      }

      return 10;
    },
    checkbox_value: {
      get() {
        return this.modelValue;
      },
      set(new_value) {
        this.$emit('update:modelValue', new_value);

        this.$emit('change');
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.checkbox {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;

  &:hover {
    .checkbox-container {
      border-color: $medium-slate-blue;
    }

    .text {
      color: $medium-slate-blue;
    }
  }

  &--active {
    .checkbox-container {
      background-color: $cornflower-blue;
      border-color: $cornflower-blue;
    }

    .text {
      color: $cornflower-blue;
    }

    &:hover {
      .checkbox-container {
        background-color: $medium-slate-blue;
        border-color: $medium-slate-blue;
      }

      .text {
        color: $medium-slate-blue;
      }
    }
  }

  &--disabled {
    cursor: not-allowed;

    .checkbox-container {
      background-color: $white;
      border-color: $amethyst-smoke;
    }

    .text {
      color: $amethyst-smoke;
    }

    &.checkbox--active {
      .checkbox-container {
        background-color: $amethyst-smoke;
      }
    }

    &:hover {
      .checkbox-container {
        background-color: $white;
        border-color: $amethyst-smoke;
      }

      .text {
        color: $amethyst-smoke;
      }
    }

    &.checkbox--active:hover {
      .checkbox-container {
        background-color: $amethyst-smoke;
        border-color: $amethyst-smoke;
      }
    }
  }
}

.checkbox-item {
  display: none;
}

.checkbox-container {
  align-items: center;
  background-color: $white;
  border: 1px solid $cornflower-blue;
  border-radius: 4px;
  display: flex;
  height: 16px;
  justify-content: center;
  width: 16px;

  &--big {
    border-width: 2px;
    height: 24px;
    width: 24px;
  }

  &--small {
    height: 12px;
    width: 12px;
  }

  svg {
    --color: #{$white};
  }
}

.text {
  color: $haiti;
  flex: 1;
}
</style>
